import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { SparklesIcon } from '../../../../web/components/svgs/icons/SparklesIcon';
import type { TimelineRow } from '../../../../queries/CallAdherence/mergeAdherenceTimeline';
import { brandPrimary } from '../../../styles/colors';
import { styleSheet } from '../styles';

const aiRoleLabel = (role: Api.AIChatRole): string => (role === Api.AIChatRole.Assistant ? 'AI Coach' : 'You (to AI)');

export const AdherenceTimelineRow: React.FC<{ row: TimelineRow }> = ({ row }) => {
	if (row.kind === 'speaker') {
		return (
			<p className={css(styleSheet.transcriptionContentLine)}>
				<span className={css(styleSheet.transcriptionContentSpeaker)}>{row.speaker}:</span> {row.line}
			</p>
		);
	}
	return (
		<p className={css(styleSheet.adherenceAiRow)}>
			<span className={css(styleSheet.adherenceAiRowIcon)}>
				<SparklesIcon style={{ color: brandPrimary }} />
			</span>
			<span className={css(styleSheet.adherenceAiRowLabel)}>{aiRoleLabel(row.role)}:</span> {row.text}
		</p>
	);
};
